import { render, staticRenderFns } from "./RouteList.vue?vue&type=template&id=1a5cfa4a&scoped=true&"
import script from "./RouteList.vue?vue&type=script&lang=js&"
export * from "./RouteList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a5cfa4a",
  null
  
)

export default component.exports